'use client'

import { useQuery } from '@tanstack/react-query'
import { getPostComments } from '../actions/comment.actions'
import type { Post } from '../../post'

export const postCommentsQueryKey = (postId: string) =>
  ['post', 'comments', postId] as const

export function usePostComments(
  postId: string,
  options?: { initialData?: Post[]; enabled?: boolean }
) {
  return useQuery({
    queryKey: postCommentsQueryKey(postId),
    queryFn: () => getPostComments(postId),
    initialData: options?.initialData,
    enabled: options?.enabled !== false && !!postId,
  })
}
